import { useQuery } from "@tanstack/react-query";
import axiosManager from "../services/axiosManager";

export const useGetRenewalStatuses = (studentId, enabled) => {
    const {
        isLoading, data: renewalStatus, error,
        refetch, isRefetching,
    } = useQuery({
        queryKey: ["student/Renewal/Status", studentId],
        queryFn: () => axiosManager.get$(`/parent/api/students/${studentId}/Renewal/Status`).then((response) => response?.data),
        retry: 0,
        cacheTime: 0,
        enabled: !!enabled && !!studentId,
    });

    return {
        isLoading,
        isRefetching,
        renewalStatus: renewalStatus || {},
        error,
        refetch,
    };
};
